import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useContractCard = (contract) => {
  return useQuery({
    queryKey: ["contractCardState", contract],
    // enabled: enabled,
    queryFn: async () =>
      callApi({
        path: "contractlist",
        command: "",
        data: JSON.stringify({
          list: { filter: { f_Id: contract, f_selectedType: "" } },
        }),
      }),
  });
};

// {"list":{"filter":{"f_Id":"NEW-NO","f_selectedType":""}}}
